import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import BreadcrumbsDropdownContentQuery, {
	type BreadcrumbsDropdownContentQuery$data,
	type BreadcrumbsDropdownContentQuery$variables,
} from './__generated__/BreadcrumbsDropdownContentQuery.graphql';

export function preloadBreadcrumbsDropdown({
	spaceKey,
	contentId,
}: {
	spaceKey: string;
	contentId?: string;
}) {
	return query<BreadcrumbsDropdownContentQuery$data, BreadcrumbsDropdownContentQuery$variables>({
		query: BreadcrumbsDropdownContentQuery,
		variables: {
			spaceKey,
			contentId,
			skipContent: !contentId,
		},
	});
}
